import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useUserRole } from "../../context/UserRoleContext";

const RoleBasedRoute = ({ children, allowedRole }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { userRole, hasCompletedSetup, loading: roleLoading } = useUserRole();
  const location = useLocation();

  // Show loading while checking authentication and role
  if (authLoading || roleLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to appropriate dashboard if role doesn't match
  if (userRole !== allowedRole) {
    // Redirect to their correct dashboard
    if (userRole === "artist") {
      return <Navigate to="/artist" replace />;
    } else if (userRole === "bar_owner") {
      return <Navigate to="/bar-owner" replace />;
    } else if (userRole === "bar_admin") {
      return <Navigate to="/bar-admin" replace />;
    }
    // If no role found, redirect to login
    return <Navigate to="/login" replace />;
  }

  // Check if bar owner needs to complete onboarding
  // BUT don't redirect if already on the onboarding page (prevents loop)
  if (
    userRole === "bar_owner" &&
    !hasCompletedSetup &&
    location.pathname !== "/bar-owner/onboarding"
  ) {
    return <Navigate to="/bar-owner/onboarding" replace />;
  }

  // Check if artist needs to complete onboarding
  // BUT don't redirect if already on the onboarding page (prevents loop)
  if (
    userRole === "artist" &&
    !hasCompletedSetup &&
    location.pathname !== "/artist/onboarding"
  ) {
    return <Navigate to="/artist/onboarding" replace />;
  }

  // User has the correct role, render the children
  return children;
};

export default RoleBasedRoute;
